module.exports = __webpack_public_path__ + "img/Orbiting-Inspect-Medium.70c0e622.png";